import React, { Suspense, lazy, useEffect } from "react";
import { useDispatch } from "react-redux";
import { reservationsApi } from "../../store/reservationsApi";
import { CalendarStoreProvider } from "../../calendar/master";

const CalendarExtremeOptimized = lazy(() =>
   import("../../components/APanel/CalendarExtreme/ACalendarOptimized"),
);

function getExtremePrefetchDate() {
   try {
      const saved = localStorage.getItem("__DV_EXTREME_MONTH");
      if (saved && /^\d{4}-\d{2}$/.test(saved)) {
         const [year, month] = saved.split("-").map(Number);
         return new Date(year, month - 1, 1);
      }
   } catch {}
   return new Date();
}

export default function APOrarExtreme() {
   const dispatch = useDispatch();

   useEffect(() => {
      document.title = "Instruire Auto | Lecții practice EXTREME";
      dispatch(
         reservationsApi.util.prefetch(
            "getReservationsForMonth",
            { date: getExtremePrefetchDate() },
            { force: false },
         ),
      );
   }, [dispatch]);

   return (
      <main className="main" style={{ padding: 0 }}>
         <Suspense
            fallback={
               <div className="dayview__loading" role="status" aria-live="polite">
                  <div className="dayview__spinner" />
                  <span>Se încarcă Lecții practice EXTREME...</span>
               </div>
            }
         >
            <CalendarStoreProvider>
               <CalendarExtremeOptimized />
            </CalendarStoreProvider>
         </Suspense>
      </main>
   );
}
